
export default function ContactHero() {
  return (
    <section 
      className="relative min-h-[50vh] flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/770ab6a18e695d59a67bcb5cff391b9d.jpg')`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Contactez <span className="text-red-500">Cobra Sécurité</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
            Notre équipe d'experts est à votre disposition pour répondre à toutes vos questions 
            et vous accompagner dans vos projets de sécurité.
          </p>
          <div className="flex flex-col sm:flex-row gap-8 justify-center items-center text-center">
            <div className="flex items-center space-x-3">
              <i className="ri-phone-line text-2xl text-red-500"></i>
              <div>
                <div className="font-bold">Urgences 24h/7j</div>
                <div className="text-gray-300">71348109</div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <i className="ri-time-line text-2xl text-red-500"></i>
              <div>
                <div className="font-bold">Réponse Rapide</div>
                <div className="text-gray-300">Sous 2h ouvrées</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
